import { BUTTON_SIZE, BUTTON_TYPE } from '../../../generic';
import Button from '../../../generic/Button';
import Flex from '../../../generic/Flex';
import { redirectToGithubAppInstallation } from '../utils';

import styles from './Fallback.module.less';

const InstallGithubAppFallback = () => {
  return (
    <div className={styles.fallback}>
      <Flex gap="8px" direction="column">
        <img src="/img/fossa-logo-circle.svg" alt="FOSSA" width="64px" />
        <div className={styles.title}>Install the FOSSA app</div>
        <div className={styles.description}>To continue, install the FOSSA app on GitHub.</div>
      </Flex>
      <Button type={BUTTON_TYPE.PRIMARY} size={BUTTON_SIZE.MEDIUM} onClick={redirectToGithubAppInstallation}>
        Install App
      </Button>
    </div>
  );
};

export default InstallGithubAppFallback;
